import { AxiosInstance } from 'axios';
import {
  CashRegisterReportServiceType,
  initCashRegisterReportService,
} from '../pages/CashRegisterReportPage/api';
import {
  initPrePaymentReportService,
  PrePaymentReportServiceType,
} from '../pages/PrepaymentArrivalReportPage/api';
import {
  initTransactionListReportService,
  TransactionListReportServiceType,
} from '../pages/TransactionsListReportPage/api';

export interface CashierReportServiceType {
  cashRegisterReport: CashRegisterReportServiceType;
  transactionsListReport: TransactionListReportServiceType;
  prePaymentReport: PrePaymentReportServiceType;
}

export const initCashierReportService = (axios: AxiosInstance): CashierReportServiceType => ({
  cashRegisterReport: initCashRegisterReportService(axios),
  transactionsListReport: initTransactionListReportService(axios),
  prePaymentReport: initPrePaymentReportService(axios),
});
